const EXP_TABLE = new Array(256);
const LOG_TABLE = new Array(256);

for (let _idx = 0; _idx < 8; _idx++) {
  EXP_TABLE[_idx] = 1 << _idx;
}

for (let _idx = 8; _idx < 256; _idx++) {
  EXP_TABLE[_idx] =
    EXP_TABLE[_idx - 4] ^ EXP_TABLE[_idx - 5] ^ EXP_TABLE[_idx - 6] ^ EXP_TABLE[_idx - 8];
}

for (let _idx = 0; _idx < 255; _idx++) {
  LOG_TABLE[EXP_TABLE[_idx]] = _idx;
}

export function glog(n) {
  if (n < 1) {
    throw new Error('glog(' + n + ')');
  }

  return LOG_TABLE[n];
}

export function gexp(n) {
  while (n < 0) {
    n += 255;
  }

  while (n >= 256) {
    n -= 255;
  }

  return EXP_TABLE[n];
}
